import { SafeHtml } from "@angular/platform-browser";

export class FirmwareVersions {
	Versions: FirmwareUpdate[];
}

export class FirmwareUpdate {
	Description: string;
	DeviceFWVersion: string;
	AvailableFWVersion: string;
	AvailableUpdate: boolean;
}

export class FirmwareUpdateDevice extends FirmwareVersions {
	Description: string;
	DeviceFWVersion: string;
	AvailableFWVersion: string;
	AvailableUpdate: boolean;
}


export class PostFirmwareUpdate {
	Component: string;
}

export class FirmwaresCategory {
	automations: FirmwaresDeviceAutomations;
	gateways: FirmwaresDeviceGateways;
	videoentrysystems: FirmwaresDeviceVideoEntry;
}

export class FirmwaresDeviceAutomations {
	rbe4: FirmwaresRepo;
	srn1: FirmwaresRepo;
	zbb2: FirmwaresRepo;
	zbb3: FirmwaresRepo;
	zbc1: FirmwaresRepo;
	zbkn: FirmwaresRepo;
	zbx7n: FirmwaresRepo;
	zc3n: FirmwaresRepo;
	zl392: FirmwaresRepo;
	zl392c: FirmwaresRepo;
	zl392d: FirmwaresRepo;
	zl57: FirmwaresRepo;
	zl65: FirmwaresRepo;
	zlb24s: FirmwaresRepo;
	zlb30a: FirmwaresRepo;
	zlb30b: FirmwaresRepo;
	zlx230p: FirmwaresRepo;
	zlx24m: FirmwaresRepo;
	zlx24s: FirmwaresRepo;
	zn7: FirmwaresRepo;
	zn7v: FirmwaresRepo;
	zn8: FirmwaresRepo;
	zn8rev: FirmwaresRepo;
}


export class FirmwaresDeviceGateways {
	camekey: FirmwaresRepo;
	camekeygw: FirmwaresRepo;
	mtmac: FirmwaresRepo;
	mtmacus: FirmwaresRepo;
	qbe: FirmwaresRepo;
	qbesh: FirmwaresRepo;
}
export class FirmwaresDeviceVideoEntry {
	lhs: FirmwaresRepo;
	lhsbt: FirmwaresRepo;
	lhspill: FirmwaresRepo;
	mtmaclte: FirmwaresRepo;
	mtmacuslte: FirmwaresRepo;
	mtmbfvs: FirmwaresRepo;
	mtmdy: FirmwaresRepo;
	mtmdyfonts: FirmwaresRepo;
	mtmrfid: FirmwaresRepo;
}

export class FirmwaresRepo {
	0: Firmware[];
}


export class Firmware {
	version: string;
	date: string;
	releaseNotes: any;
	releaseNotesMd: any;
	isTest: boolean;
	releaseNoteHtml: SafeHtml;
}
